import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#board", label: "热议榜" },
  { href: "#topics", label: "话题广场" },
  { href: "#danmaku", label: "弹幕互动" },
  { href: "#discussion", label: "热门讨论" },
  { href: "#about", label: "瓜田学堂" },
  { href: "#faq", label: "常见问题" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-[0_1px_0_0_oklch(var(--background-200))]"
          : "bg-background-50/40 backdrop-blur-sm"
      }`}
    >
      <nav className="flex items-center justify-between gap-4 px-4 md:px-6 py-3">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap" aria-label="吾爱吃瓜 回到顶部">
          <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-primary-600 text-lg shadow-sm">🍉</span>
          <span className="font-heading text-xl md:text-2xl leading-none text-foreground-950">
            吾爱<span className="text-primary-600">吃瓜</span>
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-1 lg:gap-2">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="block whitespace-nowrap rounded-full px-3 lg:px-4 py-2 text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 md:px-5 py-2 text-sm text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-chat-1-line"></i>
            加入讨论
          </a>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 hover:bg-background-100 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3 pb-6">
          <ul className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-[15px] text-foreground-800 hover:bg-background-100 hover:text-primary-600"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="mt-2">
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center gap-1.5 rounded-full bg-primary-500 px-4 py-2.5 text-[15px] text-background-50"
              >
                <i className="ri-chat-1-line"></i>
                加入讨论
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}